var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("filtro-pvtn", {
            attrs: { filtro: _vm.filtro, placeholder: "Informe o ano" },
            on: { pesquisar: _vm.pesquisar, limpar: _vm.limpar }
          })
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            { attrs: { id: "tableHeader" } },
            [
              _c("h3", { staticStyle: { marginTop: "1%", marginLeft: "1%" } }, [
                _vm._v("UPF por ano")
              ]),
              _c(
                "el-button",
                {
                  attrs: {
                    id: "addPvtnButton",
                    type: "primary",
                    round: "round",
                    size: "medium"
                  },
                  on: {
                    click: function($event) {
                      return _vm.inserirEditarUpf()
                    }
                  }
                },
                [_vm._v("Adicionar UPF +")]
              )
            ],
            1
          ),
          _c(
            "el-collapse",
            { attrs: { accordion: "accordion" } },
            _vm._l(_vm.dados, function(dado, index) {
              return _c(
                "el-collapse-item",
                { key: index, attrs: { title: dado.ano.slice(0, 4) } },
                [
                  _c("table-generica", {
                    attrs: {
                      colunas: _vm.colunas,
                      botoesAcao: _vm.botoesAcao,
                      dados: dado.upfs
                    }
                  })
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm.showModal
        ? _c(
            "app-modal",
            {
              attrs: { titulo: "Adicionar UPF" },
              on: { closeModal: _vm.closeModal }
            },
            [
              _c("template", { slot: "body" }, [
                _c(
                  "div",
                  { staticClass: "modalBody" },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("app-label", { attrs: { label: "Ano:" } }),
                        _c("el-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: ["####"],
                              expression: "['####']"
                            }
                          ],
                          staticClass: "input",
                          model: {
                            value: _vm.novaUpf.ano,
                            callback: function($$v) {
                              _vm.$set(_vm.novaUpf, "ano", $$v)
                            },
                            expression: "novaUpf.ano"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("app-label", { attrs: { label: "Mês:" } }),
                        _c(
                          "el-select",
                          {
                            model: {
                              value: _vm.novaUpf.mes,
                              callback: function($$v) {
                                _vm.$set(_vm.novaUpf, "mes", $$v)
                              },
                              expression: "novaUpf.mes"
                            }
                          },
                          _vm._l(_vm.mesesLista, function(mes, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: mes, value: mes }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("app-label", { attrs: { label: "UPF:" } }),
                        _c("app-double-input", {
                          attrs: { precision: 4, maxlength: 8 },
                          model: {
                            value: _vm.novaUpf.valor,
                            callback: function($$v) {
                              _vm.$set(_vm.novaUpf, "valor", $$v)
                            },
                            expression: "novaUpf.valor"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("template", { slot: "footer" }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: false },
                        on: { click: _vm.closeModal }
                      },
                      [_vm._v("Cancelar")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: false },
                        on: { click: _vm.salvar }
                      },
                      [_vm._v("Salvar")]
                    )
                  ],
                  1
                )
              ])
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-644014ff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-644014ff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/ConfigurarUpf.vue
// module id = null
// module chunks = 